export const SELECT_MENU_ITEM = 'SELECT_MENU_ITEM';
export const SELECT_LANGUAGE = 'SELECT_LANGUAGE';



// WEBPACK FOOTER //
// ./src/redux/actions/header/action_types.js